import "babel-polyfill/lib/index";

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueLocale from "../../utils/i18n";

// Must be imported first because loads jquery statically
import {init as jqinit} from '../../ui/jqinit';

import Settings from './settings.vue';
import Expenses from './expenses.vue';
import Debts from './debts.vue';
import App from './app.vue';
import store from 'core/store';
import {EntityWatcher} from 'core/actions';
import {create as createEntity} from 'core/entities';
import AppState from 'ui/appstate';
import SheetExpensesState from 'ui/sheet-expenses-state';


//-----------------------------------------------------------------------------
// Init datastore

{
	store.init(createEntity);
	let data = wow.init_data;
	let book = store.put(null, 'Book', data.book);
	store.globals.book = book;
	store.globals.sheet = store.put(book.key, 'Sheet', data.sheet);
	delete wow.init_data;

	new EntityWatcher(book.key).start();
}

//-----------------------------------------------------------------------------
// Init locale

Vue.use(VueLocale, {
	'language': wow.locale,
	'messages': wow.messages,
	'currency': 'EUR'
});

//-----------------------------------------------------------------------------
// Init router

Vue.use(VueRouter);

// Router
const router = new VueRouter({
	routes: [
		{path: '/settings', component: Settings},
		{
			path: '/expenses', component: Expenses,
			children: [{
				path: 'new', name: 'newRow', component: SheetExpensesState,
				props: {stateName: 'newRow'},
				meta: {backUrl: '/expenses'}
			}, {
				path: 'edit/:rowId', name: 'editRow', component: SheetExpensesState,
				props: {stateName: 'edit'},
				meta: {backUrl: '/expenses'}
			}, {
				path: 'balance', name: 'balance', component: SheetExpensesState,
				props: {stateName: 'balance'},
				meta: {backUrl: '/expenses'}
			}]
		},
		{path: '/', component: store.globals.sheet.isOpen ? Expenses : Debts},
		{path: '/debts', component: Debts}
	]
});

// Appstate
const appState = new AppState();
appState.watchRouter(router);
store.globals.appState = appState;

// App
const app = new Vue({
	router,
	render: (h) => {
		return h(App);
	}
}).$mount('#wow-app');


if (!router.currentRoute.matched.length) { // because of expense edition history management
	router.replace('/');
}

//-----------------------------------------------------------------------------
// Init jQuery stuff

jqinit();


// WEBPACK FOOTER //
// ./src/apps/anonymous/main.js